(function () {
	'use strict';
	angular.module('qbePortal').directive('qbTabs',
		function (quoteOptions, userInputRepository) {
			return {
				templateUrl: '../ngviews/directives/qbTabs.html',
				restrict: 'E',
				transclude: true,
				scope: {
					selectedTab: '<',
					setSelectedTab: '&',
				},
				link: function (scope, element, attrs) {
					scope.vm = {};

					$(element).on('changeTab.tabs', function (event, $activeTabId) {
						var $tab = $($activeTabId);
						var tabId = $tab.attr('tab-id');
						scope.setSelectedTab({
							'tabId': tabId
						});
					});

					function initTabs(selectedTab) {
						$(element).find('[tab-id=' + selectedTab + ']').addClass('is-active');
						QBE.tabs.init();
					}

					initTabs(scope.selectedTab);
				}
			};
		}
	);
})();
